import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";
import "./box.css";
import Loader from "../../Components/Loader";
import {
  CategoryService,
  SubCategoryService,
  vendorService,
} from "../../Services";
import { PhoneCode } from "../../Components";
import AutoComplete from "../AutoComplete";
import { WebRetailerService } from "../../Services/WebLinkRetailer";
import Test, { ImageCropper } from "./Test";
import ReactCrop from "react-image-crop";
import CropImageDialog from "./CropImageDialog";
import { Button } from "react-bootstrap-v5";
// import ImageResize from "./";

export const AddWebLinkRetailer = () => {
  const [loader, setLoader] = useState(false);
  const [category, setCategory] = useState(false);
  const [catdetail, setCatdetail] = useState([]);
  const [location, setLocation] = useState();
  const [allcat, setAllcat] = useState([]);
  const [active, setActive] = useState();
  const [image, setImage] = useState("");
  const [crop, setCrop] = useState();
  const [cropModal, setCropModal] = useState(false);
  const [valimg, setValimg] = useState(false);

  const history = useHistory();

  const handlesubcatChange = async (e) => {
    formik.setValues({
      ...formik.values,
      subcategory_id: e.value,
    });
  };

  const getCategory = async () => {
    await CategoryService.getCategory()
      .then((res) => {
        setAllcat(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const categoryList =
    allcat &&
    allcat.map((item, index) => {
      return {
        value: item?._id,
        label: item?.category_name,
      };
    });

  const handleCategory = async (e) => {
    formik.setValues({
      ...formik.values,
      category_id: e.value,
    });
    let obj = { id: e.value };
    await CategoryService.getCategory(obj)
      .then((res) => {
        setCatdetail(res?.data[0]?.sub_categories);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const subcatList =
    catdetail &&
    catdetail.map((item, index) => {
      return {
        value: item?._id,
        label: item?.subcategory_name,
      };
    });
  // const validFileExtensions = { image: ["jpg", "gif", "png", "jpeg", "webp"] };
  // function isValidFileType(fileName, fileType) {
  //   console.log(fileName, "fileNamefileNamefileNamefileName")
  //   return (
  //     fileName &&
  //     validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
  //   );
  // }

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      contact_number: "",
      sale_discount: "",
      retailer_logo: "",
      subcategory_id: "",
      country: "",
      city: "",
      url: "",
      retailer_discription: "",
      location: "",
      category_id: "",
    },

    validationSchema: Yup.object({
      name: Yup.string()
        // .matches(/^[A-Za-z ]*$/, "Please enter valid name")
        .required("Required"),
      location: Yup.string().required("Required"),
      category_id: Yup.string().required("Required"),
      country: Yup.string().required("Required"),
      city: Yup.string().required("Required"),
      retailer_discription: Yup.string().max(150,'Must be 150 characters').required("Required"),
      url: Yup.string().required("Required"),
      retailer_logo: Yup.string()
        // .mixed()
        // .test("is-valid-type", "Not a valid image type", (value) =>
        // console.log(value, "vvvvvvvvvvvvvvv")
          // isValidFileType(value && value.name, "image")
        // )
        // .test("svg", "Uploaded file has unsupported format.")
        // value => !value || (value && SUPPORTED_FORMATS.includes(value.type)))
        .required("Required"),
      subcategory_id: Yup.string().required("Required"),
      sale_discount: Yup.string().test(
        "global-ok",
        "Required",
        function (value) {
          if (active === "ACTIVE" && !value) {
            return false;
          } else {
            return true;
          }
        }
      ),
      email: Yup.string()
        .required("Required")
        .email("Please enter valid email"),
      contact_number: Yup.string()
        .min(10, "Too short")
        .typeError("Must be a number")
        .required("Required"),
    }),

    onSubmit: (values) => {
      let data = new FormData();
      data.append("name", formik.values.name);
      data.append("email", formik.values.email);
      data.append("contact_number", formik.values.contact_number);
      if (active) {
        data.append("sale_discount", formik.values.sale_discount);
      }
      data.append("retailer_logo", formik.values.retailer_logo);
      // let img = URL.createObjectURL(image.imageurl)
      // data.append("retailer_logo", img);
      data.append("subcategory_id", formik.values.subcategory_id);
      data.append("country", formik.values.country);
      data.append("city", formik.values.city);
      data.append("url", formik.values.url);
      data.append("location", formik.values.location);
      data.append("retailer_discription", formik.values.retailer_discription);
      if (active) {
        data.append("is_discount", formik.values.is_discount);
      }
      data.append("category_id", formik.values.category_id);

      setLoader(true);
      WebRetailerService.addWebRetailer(data)
        .then((res) => {
          if (res.status === true) {
            toast.success(res.message);
            history.push("/web-link-retailer-list");
            setLoader(false);
          } else {
            toast.error(res.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const handleCheck = (e) => {
    if (e.target.checked) {
      setActive("ACTIVE");
      formik.setValues({
        ...formik.values,
        is_discount: "ACTIVE",
      });
    } else {
      formik.setValues({
        ...formik.values,
        is_discount: "INACTIVE",
      });
      setActive("INACTIVE");
    }
  };

  // const getDestinationData = (e) => {
  //   let link = `https://www.google.com/maps/search/?api=1&query=${e.latitude},${e.longitude}`;
  //   setLocation(link);
  //   formik.setValues({
  //     ...formik.values,
  //     location: link,
  //   });
  // };


  useEffect(() => {
    getCategory();
  }, []);

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="row">
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Category</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.category_id
                            ? !formik.errors.category_id
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      onChange={(e) => handleCategory(e)}
                      options={categoryList}
                    />
                    {formik.touched.category_id && formik.errors.category_id ? (
                      <div className="text-danger">
                        {formik.errors.category_id}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Sub Category</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.subcategory_id
                            ? !formik.errors.subcategory_id
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      onChange={(e) => handlesubcatChange(e)}
                      options={subcatList}
                    />
                    {formik.touched.subcategory_id &&
                    formik.errors.subcategory_id ? (
                      <div className="text-danger">
                        {formik.errors.subcategory_id}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Name</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.name
                          ? !formik.errors.name
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("name")}
                      placeholder="Enter Name"
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="text-danger">{formik.errors.name}</div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Contact No.</label>
                  </div>
                  <div className="col-9">
                    <div
                      className={
                        formik.touched.contact_number
                          ? !formik.errors.contact_number
                            ? " contact-success"
                            : " contact-error"
                          : ""
                      }
                    >
                      <PhoneCode
                        Addphone={(value) =>
                          formik.setValues({
                            ...formik.values,
                            contact_number: value,
                          })
                        }
                        phone={formik.values.contact_number}
                      />
                    </div>
                    {formik.touched.contact_number &&
                    formik.errors.contact_number ? (
                      <div className="text-danger">
                        {formik.errors.contact_number}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Email ID</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="email"
                      className={
                        "form-control" +
                        (formik.touched.email
                          ? !formik.errors.email
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("email")}
                      placeholder="Enter Email"
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <div className="text-danger">{formik.errors.email}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Logo</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="file"
                      className={
                        "form-control" +
                        (formik.touched.retailer_logo
                          ? !formik.errors.retailer_logo
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      onChange={(e) => {
                        if(e.target.files[0].name.split(".").at(-1) === "svg"){
                          setValimg(true)
                        }else{
                          setValimg(false)
                        formik.setFieldValue(
                          "retailer_logo",
                          e.target.files[0],
                        );
                        // setImage(URL.createObjectURL(e.target.files[0]));
                        setImage({
                          imageurl: URL.createObjectURL(e.target.files[0]),
                          image: e.target.files,
                        });
                        }
                      }}
                    />
                    {
                      valimg === true &&
                    <p className="text-danger">Uploaded file has unsupported format</p>
                    }
                    {formik.touched.retailer_logo &&
                    formik.errors.retailer_logo ? (
                      <div className="text-danger">
                        {formik.errors.retailer_logo}
                      </div>
                    ) : null}
                  </div>
                </div>

                
                {image.imageurl && (
                  <div className="mb-3 row">
                    <div className="col-3"></div>
                    <div className="col-9">
                    <div className="Retailer-name ">
                    <div className="retailer-images">
                      <img
                        // style={{ width: 100, height: 100 }}
                        src={image.imageurl}
                      />
                    </div>
                  

                </div>
                      <Button
                      style={{marginLeft : 58}}
                        className="mt-2"
                        onClick={() => setCropModal(true)}
                      >
                        crop
                      </Button>
                      {cropModal && (
                        <CropImageDialog
                          cropModal={cropModal}
                          setCropModal={setCropModal}
                          imagedata={image}
                          setNewImage={setImage}
                          setFieldValue={formik.setFieldValue}
                        />
                      )}
                      {/* <ReactCrop crop={crop} onChange={c => setCrop(c)}>
                      <img style={{ width: 100, height: 100 }} src={image} />
                      <img src={image} />
                    </ReactCrop> */}
                    </div>
                  </div>
                )}
                <div className="mb-3 row">
                  <div className="col-sm-3">
                    {" "}
                    <label className="form-label">Offer</label>
                  </div>
                  <div className="col-sm-9 row ms-1">
                    <div className="form-check col-sm-2">
                      <input
                        onChange={(e) => {
                          handleCheck(e);
                        }}
                        className="form-check-input"
                        type="checkbox"
                        value="active"
                        id="flexCheckDefault"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                      >
                        Active
                      </label>
                    </div>
                  </div>
                </div>

                {formik.values.is_discount === "ACTIVE" ? (
                  <div className="mb-3 row">
                    <div className="col-3">
                      <label className="form-label">Offer detail</label>
                    </div>
                    <div className="col-9">
                      <input
                        required={false}
                        type="text"
                        name="sale_discount"
                        className={
                          "form-control" +
                          (formik.touched.sale_discount
                            ? !formik.errors.sale_discount
                              ? " is-valid"
                              : " is-invalid"
                            : "")
                        }
                        {...formik.getFieldProps("sale_discount")}
                        placeholder="Enter Discount"
                      />
                      {formik.touched.sale_discount &&
                      formik.errors.sale_discount ? (
                        <div className="text-danger">
                          {formik.errors.sale_discount}
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  " "
                )}

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Retailer Website</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.url
                          ? !formik.errors.url
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("url")}
                      placeholder="Enter URL"
                    />
                    {formik.touched.url && formik.errors.url ? (
                      <div className="text-danger">{formik.errors.url}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">City</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.city
                          ? !formik.errors.city
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("city")}
                      placeholder="Enter City"
                    />
                    {formik.touched.city && formik.errors.city ? (
                      <div className="text-danger">{formik.errors.city}</div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Country</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.country
                          ? !formik.errors.country
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("country")}
                      placeholder="Enter Country"
                    />
                    {formik.touched.country && formik.errors.country ? (
                      <div className="text-danger">{formik.errors.country}</div>
                    ) : null}
                  </div>
                </div>

                {/* <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Location</label>
                  </div>
                  <div className="col-9">
                    <AutoComplete
                      getData={(e) => getDestinationData(e)}
                    ></AutoComplete>
                    {formik.touched.url && formik.errors.url ? (
                      <div className="text-danger">{formik.errors.url}</div>
                    ) : null}
                  </div>
                </div> */}

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Location</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.location
                          ? !formik.errors.location
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("location")}
                      placeholder="location"
                    />
                    {formik.touched.location && formik.errors.location ? (
                      <div className="text-danger">
                        {formik.errors.location}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Description</label>
                  </div>
                  <div className="col-9">
                    <textarea
                      required={false}
                      type="textarea"
                      name="retailer_discription"
                      className={
                        "form-control" +
                        (formik.touched.retailer_discription
                          ? !formik.errors.retailer_discription
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("retailer_discription")}
                      placeholder="Type description"
                    ></textarea>
                    {formik.touched.retailer_discription &&
                    formik.errors.retailer_discription ? (
                      <div className="text-danger">
                        {formik.errors.retailer_discription}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light me-3"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
              {/* <ImageCropper/> */}
            </form>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddWebLinkRetailer;
